function getCollectionProductGrid(scope) {
  if (scope?.id === 'product-grid') return scope;
  if (scope?.querySelector) return scope.querySelector('#product-grid');
  return document.getElementById('product-grid');
}

function cancelScrollTriggersInScope(scope) {
  const grid = getCollectionProductGrid(scope);
  const container = document.getElementById('ProductGridContainer');
  const roots = new Set([grid, container, scope, scope?.parentElement].filter(Boolean));

  roots.forEach((root) => {
    if (!root?.querySelectorAll) return;

    root.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
      element.classList.remove('scroll-trigger--offscreen');
    });
  });
}

function runCollectionCardInits() {
  if (typeof initCardVariantButtons === 'function') initCardVariantButtons();
  if (typeof initCardRfqButtons === 'function') initCardRfqButtons();
  if (typeof initCardAddToCartButtons === 'function') initCardAddToCartButtons();
  if (typeof initAccountRequiredMarquees === 'function') initAccountRequiredMarquees();
}

window.initCollectionProductEnhancements = function initCollectionProductEnhancements(scope) {
  cancelScrollTriggersInScope(scope);
  runCollectionCardInits();
};

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('product-grid')) {
    window.initCollectionProductEnhancements();
  }
});
